import { CPDialogResult } from "../enums/CPDialogResult";
import { CRUDActions } from "../enums/CRUDActions";

export class ConfirmOutput
{
    action: CRUDActions;
    dialogResult: CPDialogResult;
    data: any;
    code: string;
}
